module.exports = __webpack_public_path__ + "assets/img/phone-ru-1.53d4b624.webp";